import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  TextField,
  Select,
} from '@mui/material';
import dayjs from 'dayjs';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
import { BACK } from '../config';

// ----------------------------------------------------------------------
const { kakao } = window;
function Kakao({ latitude, longitude, illegal, setInputLatitude, setInputLongitude }) {
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const zoomIn = () => {
    const level = map.getLevel();

    // 지도를 1레벨 내립니다 (지도가 확대됩니다)
    map.setLevel(level - 1);
  };

  const zoomOut = () => {
    const level = map.getLevel();

    // 지도를 1레벨 내립니다 (지도가 확대됩니다)
    map.setLevel(level + 1);
  };

  useEffect(() => {
    kakao.maps.load(() => {
      const mapContainer = document.getElementById('map'); // 지도를 표시할 div
      const mapOption = {
        center: new kakao.maps.LatLng(latitude, longitude), // 지도의 중심좌표
        level: 3, // 지도의 확대 레벨
      };
      const myMap = new kakao.maps.Map(mapContainer, mapOption);
      const markerPosition = new kakao.maps.LatLng(latitude, longitude);
      const myMarker = new kakao.maps.Marker({
        position: markerPosition,
      });
      myMarker.setDraggable(true);
      const dragEventHandler = () => {
        // alert('marker dragend!');
        const lat = myMarker.getPosition().getLat();
        const lng = myMarker.getPosition().getLng();
        setInputLatitude(lat);
        setInputLongitude(lng);
      };
      kakao.maps.event.addListener(myMarker, 'dragend', dragEventHandler);

      const imageSrc = 'https://t1.daumcdn.net/mapjsapi/images/2x/marker.png';
      const imageSize = new kakao.maps.Size(13, 19); // 마커이미지의 크기입니다
      const imageOption = { offset: new kakao.maps.Point(6.5, 19) }; // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.

      const markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize, imageOption);
      myMarker.setImage(markerImage);
      myMarker.setMap(myMap);
      setMap(myMap);
      setMarker(myMarker);
    });
  }, []);
  useEffect(() => {
    if (map !== null && marker !== null) {
      map.panTo(new kakao.maps.LatLng(latitude, longitude));
      marker.setPosition(new kakao.maps.LatLng(latitude, longitude));
    }
    // marker update
  }, [latitude, longitude]);

  useEffect(() => {
    if (marker !== null) {
      if (illegal < 5) {
        const imageSrc = 'https://t1.daumcdn.net/mapjsapi/images/2x/marker.png';
        const imageSize = new kakao.maps.Size(13, 19); // 마커이미지의 크기입니다
        const imageOption = { offset: new kakao.maps.Point(6.5, 19) }; // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.

        const markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize, imageOption);
        marker.setImage(markerImage);
      } else {
        const imageSrc = 'https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/marker_red.png'; // 마커이미지의 주소입니다
        const imageSize = new kakao.maps.Size(16, 17.5); // 마커이미지의 크기입니다
        const imageOption = { offset: new kakao.maps.Point(6.5, 17.5) }; // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.

        // 마커의 이미지정보를 가지고 있는 마커이미지를 생성합니다
        const markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize, imageOption);
        // 마커를 생성합니다
        marker.setImage(markerImage);
      }
    }
  }, [illegal]);

  // 지도를 표시할 div와  지도 옵션으로  지도를 생성합니다

  return (
    <>
      <div id="map" style={{ width: '100%', height: '500px' }}>
        {' '}
      </div>
      <Button onClick={zoomIn}>확대</Button>
      <Button onClick={zoomOut}>축소</Button>
    </>
  );
}
const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'company', label: 'Company', alignRight: false },
  { id: 'role', label: 'Role', alignRight: false },
  { id: 'isVerified', label: 'Verified', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: '' },
];

const TALBE_HEAD1 = [
  { id: 'id', label: 'ID', alignRight: false },
  { id: 'password', label: 'PASSWORD', alignRight: false },
  { id: 'name', label: 'NAME', alignRight: false },
  { id: 'phoneNum', label: 'PHONE_NUM', alignRight: false },
  { id: 'investCnt', label: 'INVEST_CNT', alignRight: false },
  { id: '' },
];

const TALBE_HEAD2 = [
  { id: 'idx', label: 'IDX', alignRight: false },
  { id: 'carNum', label: 'CAR_NUM', alignRight: false },
  { id: 'illegal', label: 'ILLEGAL', alignRight: false },
  { id: 'longitude', label: 'LONGITUDE', alignRight: false },
  { id: 'latitude', label: 'LATITUDE', alignRight: false },
  { id: 'date', label: 'DATE', alignRight: false },
  { id: 'dayNight', label: 'DAY_NIGHT', alignRight: false },
];

const TALBE_HEAD3 = [
  { id: 'idx', label: 'IDX', alignRight: false },
  { id: 'carNum', label: 'CAR_NUM', alignRight: false },
  { id: 'illegal', label: 'ILLEGAL', alignRight: false },
  { id: 'longitude', label: 'LONGITUDE', alignRight: false },
  { id: 'latitude', label: 'LATITUDE', alignRight: false },
  { id: 'date', label: 'DATE', alignRight: false },
  { id: 'dayNight', label: 'DAY_NIGHT', alignRight: false },
];

// ----------------------------------------------------------------------
/*
function getGeoPosition() {
  const apiGeolocationSuccess = (position) => {
    console.log(`${position.coords.latitude}  ${position.coords.longitude}`);
    alert(
      `'API geolocation success!\n\nlat = ' + ${position.coords.latitude} + '\nlng = ' + ${position.coords.longitude}`
    );
  };

  const tryAPIGeolocation = function () {
    fetch
      .post('https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyDCa1LUe1vOczX1hO_iGYgyo8p_jYuGOPU')
      .then((success) => {
        apiGeolocationSuccess({ coords: { latitude: success.location.lat, longitude: success.location.lng } });
      })
      .catch((err) => {
        alert(`API Geolocation error! \n\n ${err}`);
      });
  };

  const browserGeolocationSuccess = (position) => {
    alert(`Browser geolocation success!\n\nlat =  ${position.coords.latitude} \nlng = ${position.coords.longitude}`);
  };

  const browserGeolocationFail = (error) => {
    switch (error.code) {
      case error.TIMEOUT:
        alert('Browser geolocation error !\n\nTimeout.');
        break;
      case error.PERMISSION_DENIED:
        if (error.message.indexOf('Only secure origins are allowed') === 0) {
          tryAPIGeolocation();
        }
        break;
      case error.POSITION_UNAVAILABLE:
        alert('Browser geolocation error !\n\nPosition unavailable.');
        break;
      default:
        console.log(error);
    }
  };

  const tryGeolocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(browserGeolocationSuccess, browserGeolocationFail, {
        maximumAge: 50000,
        timeout: 20000,
        enableHighAccuracy: true,
      });
    }
  };

  tryGeolocation();
}
*/
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, orderBy) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user[orderBy].toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ReportPage() {
  const [USERLIST, setUSERLIST] = useState([]);
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [inputName, setInputName] = useState('');

  const [inputPhoneNum, setInputPhoneNum] = useState('');

  const [inputCarNum, setInputCarNum] = useState('');

  const [inputCarType, setInputCarType] = useState(1);

  const [inputIllegal, setInputIllegal] = useState(1);

  const [inputLatitude, setInputLatitude] = useState(35.8714354);

  const [inputLongitude, setInputLongitude] = useState(128.601445);

  const [investCnt, setInvestCnt] = useState(0);

  const [inputGradient, setInputGradient] = useState('');

  const id = localStorage.getItem('id');

  const name = localStorage.getItem('name');

  const browserGeolocationSuccess = (position) => {
    // alert(`${position.coords.latitude} ${position.coords.longitude}`);
    console.log(position.coords.latitude);
    console.log(position.coords.longitude);
    setInputLatitude(position.coords.latitude);
    setInputLongitude(position.coords.longitude);
    // alert(`Browser geolocation success!\n\nlat =  ${position.coords.latitude} \nlng = ${position.coords.longitude}`);
  };

  const browserGeolocationFail = (error) => {
    switch (error.code) {
      case error.TIMEOUT:
        console.log('Browser geolocation error !\n\nTimeout.');
        break;
      case error.PERMISSION_DENIED:
        if (error.message.indexOf('Only secure origins are allowed') === 0) {
          console.log('Only secure origins are allowed');
          // tryAPIGeolocation();
        }
        break;
      case error.POSITION_UNAVAILABLE:
        console.log('Browser geolocation error !\n\nPosition unavailable.');
        break;
      default:
        console.log(error);
    }
  };
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(browserGeolocationSuccess, browserGeolocationFail, {
        maximumAge: 0,
        timeout: 20000,
        enableHighAccuracy: true,
      });
    }
  }, []);
  useEffect(() => {
    // getGeoPosition();
    if (id) {
      fetch(`${BACK}/investCnt`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id,
        }),
      })
        .then((res) => {
          console.log(res.status);
          if (res.status === 200) return res.json();
          throw Error('err');
        })
        .then((data) => {
          setInvestCnt(data.investCnt);
        });
    }
  }, [investCnt]);

  useEffect(() => {
    const apiGeolocationSuccess = (position) => {
      console.log(`${position.coords.latitude}  ${position.coords.longitude}`);

      // alert(`'API geolocation success!\n\nlat = ' + ${position.coords.latitude} + '\nlng = ' + ${position.coords.longitude}`);
    };

    const tryAPIGeolocation = function () {
      fetch('https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyDCa1LUe1vOczX1hO_iGYgyo8p_jYuGOPU', {
        method: 'POST',
      })
        .then((success) => {
          apiGeolocationSuccess({ coords: { latitude: success.location.lat, longitude: success.location.lng } });
        })
        .catch((err) => {
          console.log(`API Geolocation error! \n\n ${err}`);
        });
    };

    /*
    setInterval(() => {
      tryGeolocation();
    }, 3000);
    */
    /*
    setInterval(() => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log(position.coords.latitude);
          setInputLatitude(position.coords.latitude);
          console.log(position.coords.longitude);
          setInputLongitude(position.coords.longitude);
        },
        (err) => {
          // alert(err);
          console.log({ err });
        },
        { timeout: 1000 }
      );
    }, 10000);
    */
  }, []);

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  return (
    <>
      <Helmet>
        <title> 창일 </title>
      </Helmet>

      <Container>
        <Card>
          <Stack direction="row" alignItems="center" mb={5}>
            <Table>
              <TableBody>
                <TableRow>
                  <Stack direction="col" alignItems="center" justifyContent="space-between" mb={5}>
                    <TableCell>
                      <Typography variant="h4" gutterBottom>
                        주차실태
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          localStorage.removeItem('token');
                          localStorage.removeItem('id');
                          localStorage.removeItem('name');
                          localStorage.removeItem('type');
                          window.location.href = '/';
                        }}
                      >
                        로그아웃
                      </Button>
                    </TableCell>
                  </Stack>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography>
                      {name} : {investCnt}건
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <TextField
                      label="차량번호"
                      variant="standard"
                      value={inputCarNum}
                      inputProps={{
                        inputMode: 'text',
                        lang: 'ko',
                        autoComplete: 'off',
                        autoCorrect: 'off',
                        spellCheck: false,
                      }}
                      helperText="숫자와 한글만 입력"
                      onChange={(e) => {
                        const value = e.target.value.replace(/\s/g, '');
                        setInputCarNum(value);
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <TextField
                      label="경사도"
                      variant="standard"
                      value={inputGradient}
                      helperText="0~50 사이 숫자만 입력"
                      inputProps={{
                        inputMode: 'numeric',
                        maxLength: 2,
                      }}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');

                        if (value === '') {
                          setInputGradient('');
                          return;
                        }

                        const numberValue = Number(value);

                        if (numberValue >= 0 && numberValue <= 50) {
                          setInputGradient(value);
                        }
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Select
                      label="차량종류"
                      variant="standard"
                      value={inputCarType}
                      onChange={(e) => {
                        setInputCarType(e.target.value);
                      }}
                    >
                      <MenuItem value={1}>승용/승합</MenuItem>
                      <MenuItem value={5}>소형트럭/버스(비영업용)</MenuItem>
                      <MenuItem value={6}>소형트럭/버스(영업용)</MenuItem>
                      <MenuItem value={7}>대형트럭/버스(비영업용)</MenuItem>
                      <MenuItem value={8}>대형트럭/버스(영업용)</MenuItem>
                      <MenuItem value={9}>캠핑카</MenuItem>
                      <MenuItem value={4}>기타(특수차량)</MenuItem>
                    </Select>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Select
                      label="적법/불법"
                      variant="standard"
                      value={inputIllegal}
                      onChange={(e) => {
                        setInputIllegal(e.target.value);
                      }}
                    >
                      <MenuItem value={1}>주차면(적법)</MenuItem>
                      <MenuItem value={2}>흰색선(적법)</MenuItem>
                      <MenuItem value={3}>이면도로(적법)</MenuItem>
                      <MenuItem value={4}>나대지(적법)</MenuItem>
                      <MenuItem value={5}>황색실선/점선(불법)</MenuItem>
                      <MenuItem value={6}>보도 위(불법)</MenuItem>
                      <MenuItem value={7}>기타(불법)</MenuItem>
                    </Select>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    style={{ width: '100%', justifyContent: 'center', alignContent: 'center', display: 'flex' }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => {
                        if (inputCarNum === '') {
                          return alert('차량번호를 적어주세요');
                        }
                        if (!/^[0-9가-힣]+$/.test(inputCarNum)) {
                          return alert('차량번호는 숫자와 한글만 입력해주세요');
                        }
                        const gradientNumber = inputGradient ==='' ? null : Number(inputGradient);
                        if (gradientNumber !== null && (gradientNumber < 0 || gradientNumber > 50)){
                          return alert('경사도는 0~50 사이 숫자로 입력해주세요')
                        }
                        fetch(`${BACK}/createInvestigation`, {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json',
                          },
                          body: JSON.stringify({
                            carNum: inputCarNum,
                            carType: inputCarType,
                            illegal: inputIllegal,
                            longitude: inputLongitude,
                            latitude: inputLatitude,
                            investor: id,
                            dayNight: dayjs().hour() < 6 || dayjs().hour() > 18 ? 1 : 0,
                            gradient : gradientNumber,
                          }),
                        })
                          .then((res) => {
                            console.log(res.status);
                            return res.json();
                          })
                          .then((data) => {
                            console.log(data);
                            setInvestCnt(investCnt + 1);
                            setInputCarNum('');
                            setInputGradient('');
                            alert('전송 완료!');
                          });
                        return 0;
                      }}
                    >
                      전송
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <TextField
                      key={inputLatitude}
                      disabled
                      label="위도"
                      variant="standard"
                      defaultValue={inputLatitude}
                      onChange={(e) => {
                        setInputLatitude(e.target.value);
                      }}
                      onClick={() => {
                        alert('hi');
                        navigator.geolocation.getCurrentPosition((position) => {
                          alert(position.coords.latitude);
                          console.log(position.coords.longitude);
                        });
                      }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <TextField
                      key={inputLongitude}
                      disabled
                      label="경도"
                      variant="standard"
                      defaultValue={inputLongitude}
                      onChange={(e) => {
                        setInputLongitude(e.target.value);
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Stack>
        </Card>
      </Container>
      <Container>
        <Card>
          <Kakao
            latitude={inputLatitude}
            longitude={inputLongitude}
            illegal={inputIllegal}
            setInputLatitude={setInputLatitude}
            setInputLongitude={setInputLongitude}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          수정
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          삭제
        </MenuItem>
      </Popover>
    </>
  );
}
